module.exports = __webpack_public_path__ + "img/fiveday1-1.81917190.jpg";